module.exports = __webpack_public_path__ + "img/ware1.2f258e8e.png";